import { DialogTitle, IconButton, Stack } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

type DraggableDialogTitleProps = {
    icon?: React.ReactNode;
    title: string;
    onClose: () => void;
};

export function DraggableDialogTitle({
    icon = null,
    title,
    onClose,
 }: DraggableDialogTitleProps) {
    const [isDragging, setIsDragging] = useState(false);
    
    return (
        <Stack
            direction="row"
            sx={{ background: '#bdbdbd'}}
        >
            {icon && (
                <IconButton
                    sx={{
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    {icon}
                </IconButton>
            )}
            <DialogTitle
                id="draggable-dialog-title"
                onMouseDown={() => setIsDragging(true)}
                onMouseUp={() => setIsDragging(false)}
                style={{
                    cursor: isDragging ? 'grabbing' : 'grab'
                }}
                sx={{
                    flex: 1,
                    pl: icon ? '0px' : '12px',
                    pt: '6px',
                    pb: '4px',
                    fontSize: '18px',
                }}
            >
                {title}
            </DialogTitle>
            <IconButton
                aria-label='close'
                onClick={onClose}
                sx={{
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: 'text.primary',
                    },
                }}
            >
                <CloseIcon />
            </IconButton>
        </Stack>
    )
}